/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiDetectionBoundingBoxFromJSON, StreemApiDetectionBoundingBoxToJSON, } from './';
export function WallItemStreemshotDetectionsDetectionFromJSON(json) {
    return WallItemStreemshotDetectionsDetectionFromJSONTyped(json, false);
}
export function WallItemStreemshotDetectionsDetectionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'detectionId': !exists(json, 'detection_id') ? undefined : json['detection_id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'confidence': !exists(json, 'confidence') ? undefined : json['confidence'],
        'boundingBox': !exists(json, 'bounding_box') ? undefined : StreemApiDetectionBoundingBoxFromJSON(json['bounding_box']),
        'source': !exists(json, 'source') ? undefined : json['source'],
        'extractor': !exists(json, 'extractor') ? undefined : json['extractor'],
        'lastUpdatedAt': !exists(json, 'last_updated_at') ? undefined : (new Date(json['last_updated_at'])),
    };
}
export function WallItemStreemshotDetectionsDetectionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'detection_id': value.detectionId,
        'type': value.type,
        'description': value.description,
        'confidence': value.confidence,
        'bounding_box': StreemApiDetectionBoundingBoxToJSON(value.boundingBox),
        'source': value.source,
        'extractor': value.extractor,
        'last_updated_at': value.lastUpdatedAt === undefined ? undefined : (value.lastUpdatedAt.toISOString()),
    };
}
/**
* @export
* @enum {string}
*/
export var WallItemStreemshotDetectionsDetectionType;
(function (WallItemStreemshotDetectionsDetectionType) {
    WallItemStreemshotDetectionsDetectionType["FULLTEXT"] = "DETECTION_TYPE_FULL_TEXT";
    WallItemStreemshotDetectionsDetectionType["INVALID"] = "DETECTION_TYPE_INVALID";
    WallItemStreemshotDetectionsDetectionType["LABEL"] = "DETECTION_TYPE_LABEL";
    WallItemStreemshotDetectionsDetectionType["LOGO"] = "DETECTION_TYPE_LOGO";
    WallItemStreemshotDetectionsDetectionType["MODEL"] = "DETECTION_TYPE_MODEL";
    WallItemStreemshotDetectionsDetectionType["OBJECT"] = "DETECTION_TYPE_OBJECT";
    WallItemStreemshotDetectionsDetectionType["SAFESEARCH"] = "DETECTION_TYPE_SAFE_SEARCH";
    WallItemStreemshotDetectionsDetectionType["SERIAL"] = "DETECTION_TYPE_SERIAL";
    WallItemStreemshotDetectionsDetectionType["TEXT"] = "DETECTION_TYPE_TEXT";
})(WallItemStreemshotDetectionsDetectionType || (WallItemStreemshotDetectionsDetectionType = {}));
/**
* @export
* @enum {string}
*/
export var WallItemStreemshotDetectionsDetectionSource;
(function (WallItemStreemshotDetectionsDetectionSource) {
    WallItemStreemshotDetectionsDetectionSource["AUTO"] = "DETECTION_SOURCE_AUTO";
    WallItemStreemshotDetectionsDetectionSource["INVALID"] = "DETECTION_SOURCE_INVALID";
    WallItemStreemshotDetectionsDetectionSource["OCR"] = "DETECTION_SOURCE_OCR";
    WallItemStreemshotDetectionsDetectionSource["USER"] = "DETECTION_SOURCE_USER";
})(WallItemStreemshotDetectionsDetectionSource || (WallItemStreemshotDetectionsDetectionSource = {}));
//# sourceMappingURL=WallItemStreemshotDetectionsDetection.js.map